import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import { getCategoryPlaceholderSrc } from '../../config/placeholderImages';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  const categoryId = listing?.attributes?.publicData?.categoryLevel1;
  const placeholderSrc = getCategoryPlaceholderSrc(categoryId);
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        placeholderSrc={placeholderSrc}
      />
    </section>
  );
};

export default SectionGallery;
